export default __webpack_public_path__ + "static/OpenSans-Regular-188a1c0f9d2b7f26a0746e70af32d20a.woff";